import { ImportedNgModuleProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import {Store} from '@softline/core';
import {SOFTLINE_FEATURE_TRANSLATION, TranslationStore} from '@softline/ui-core';
import {ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS} from '@softline/application';
import {default as de} from '../i18n/de.json';
import {SOFTLINE_PERMISSION_ARTIKELINFO} from './product-scan.shared';
import {EntityGuard} from './guard/entity.guard';

export const artikelinfoProviders: (Provider | ImportedNgModuleProviders)[] = [
  provideEnvironmentInitializer(() => {
      const store = inject(Store);
      store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: 'artikelinfo',
        language: 'de',
        translations: de
      });
      store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
        name: '#PRODUCT_SCAN.APP',
        icon: 'fa-regular fa-memo-circle-info',
        route: '/artikelinfo',
        permission: SOFTLINE_PERMISSION_ARTIKELINFO
      });
    }),
  EntityGuard
];
